import * as React from 'react'

type SnackbarType = 'success' | 'error'

const DISPLAY_TIME_MS = 5000

export function useSnackbar() {
  const [showSnackbar, setShowSnackbar] = React.useState(false)
  const [snackbarText, setSnackbarText] = React.useState('')
  const [snackbarType, setSnackbarType] = React.useState<SnackbarType>('success')

  React.useEffect(() => {
    if (showSnackbar) {
      const timeout = setTimeout(() => {
        setShowSnackbar(false)
      }, DISPLAY_TIME_MS)

      return () => {
        clearTimeout(timeout)
      }
    }
  }, [showSnackbar])

  const setData = React.useCallback(
    (data: { showSnackbar: boolean; type: SnackbarType; text?: string }) => {
      setShowSnackbar(data.showSnackbar)
      setSnackbarType(data.type)
      setSnackbarText(data.text || '')
    },
    [],
  )

  return {
    show: showSnackbar,
    text: snackbarText,
    type: snackbarType,
    setData,
  }
}
